import { LOCAL_STORAGE_KEY } from "components/Graph/constants.ts";
import { GraphId, Highlight, HighlightState } from "components/Graph/types.ts";
import { useUser } from "hooks/useUser.ts";

export type HighlightsLocalStorageLeaf = Record<string, { state: HighlightState; color: string }>;

interface HighlightsLocalStorage {
    [userId: string]: {
        [graphId: string]: HighlightsLocalStorageLeaf;
    };
}

export const useHighlightsLocalStorage = () => {
    const { id } = useUser().getAuthenticatedUser() || {};

    const get = (graphId: GraphId) => {
        const storageObject = localStorage.getItem(LOCAL_STORAGE_KEY);

        if (!storageObject) {
            return {};
        }
        try {
        const parsed = JSON.parse(storageObject) as HighlightsLocalStorage;

        return parsed?.[id ?? ""]?.[graphId] ?? {};
        } catch {
                        return {};
                   }

    };

    const set = <T>(data: Highlight<T>[], graphId: string) => {
        if (!id) {
            return;
        }

        const storageObject = localStorage.getItem(LOCAL_STORAGE_KEY);
        let parsed: HighlightsLocalStorage = {};
        if (storageObject) {
            try {
                parsed = JSON.parse(storageObject) as HighlightsLocalStorage;
            } catch {
                // Reset corrupted storage
            }
        }

        const userGraphs = parsed[id] || {};
        const graphData: HighlightsLocalStorageLeaf = {};

        data.forEach(({ key, state, color }) => {
            graphData[key as string] = { state, color };
        });

        const updatedUserGraphs = { ...userGraphs, [graphId]: graphData };
        const updatedStorageObject = { ...parsed, [id]: updatedUserGraphs };

        try {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedStorageObject));
        } catch (error) {
            if (error instanceof DOMException && error.name === "QuotaExceededError") {
                console.warn("LocalStorage quota exceeded, clearing highlights");
                localStorage.removeItem(LOCAL_STORAGE_KEY);
            }
        }
    };

    return { get, set };
};
